export const ro = {
	navbarMenu: {
		dashboard: "Panou de control",
		properties: "Proprietăți",
		outstanding: "Plăți",
		documents: "Documente",
		utilities: "Utilități",
		financialStatus: "Situație financiară",
		statements: "Finante",
		notifications: "Notificări",
		tickets: "Tichete",
		securityDeposits: "Garanții",
		profile: "Profil",
		subscription: "Abonament",
		payments: "Plăți",
		messages: "Mesaje",
		customOwnerPlans: "Pachete de servicii",
		financialStatements: "Situații financiare",
	},
	types: {
		tax: "Impozit",
		centralHeatingVerification: "Verificare centrala",
		insurance: "Asigurare",
		rent: "Chirie",
		other: "Altele",
		administrationContract: "Contract de administrare",
		gasContract: "Contract de gaz",
		electricityContract: "Contract de curent",
		waterContract: "Contract de apa",
		optionalInsurance: "Asigurare Facultativa",
		gasVerification: "Verificare gaz",
		gasRevision: "Revizie Gaz",
		lastGasInvoice: "Copie factura gaz",
		lastElectricityInvoice: "Copie factura curent",
		lastWaterInvoice: "Copie factura apa",
		tenantAssociationCertificate: "Adeverinta asociatie locatari",
		sanitationDeclaration: "Declaratie de salubritate",
		aquisitionAct: "Act de dobandire",
		entryReport: "Proces verbal de intrare",
		exitReport: "Proces verbal de iesire",
		observationReport: "Constatare",
		formerTenant: "Fost chirias",
		markFormer: "Marchează ca fost chiriaș",
		markActive: "Marchează ca activ",
		ownerSpouse: "Partener proprietar",
		buildingSuper: "Administrator bloc",
		headOfTenantAssociation: "Sef asociatie de locatari",
		cityHall: "Primarie",
		finances: "Finante",
		water: "Apa",
		gas: "Gaz",
		electricity: "Curent",
		internet: "Internet",
		gasUtility: "Gaz",
		electricityUtility: "Curent",
		waterUtility: "Apa",
		internetUtility: "Internet",
		sanitationUtility: "Salubritate",
		cleaningUtility: "Curatenie",
		administrationFee: "Comision de administrare",
		protocol: "Proces verbal",
		lease: "Contract de închiriere",
		custodyCash: "Custodie numerar",
		custodyBank: "Custodie bancară",
		total: "Total",
		owner: "Proprietar",
		returned: "Returnat",
		returnedTenant: "Returnat chiriașului",
		extension: "Prelungire",
		termination: "Reziliere",
		rentModification: "Modificare chirie",
		c168: "Declaratie C168",
		pending: "În așteptare",
		done: "Finalizat",
		new: "Nou",
		gasAccount: "Cont de gaz",
		electricityAccount: "Cont de curent",
		waterAssociation: "Asociatie apa",
		ownerIdentificationDocument: "Buletin proprietar",
		tenantAssociationAnnouncement: "Anunt asociatie locatari",
		tenants: "Chiriași",
		jobCertificate: "Adeverinta de serviciu",
		meterPictures: "Poze contor",
	},
	dashboard: {
		expiringLeases: "Închirieri care expiră",
		expiringDocuments: "Documente care expiră",
		revenue: "Venituri",
		properties: "Proprietăți",
		securityDeposits: "Garantii",
		monthlyRevenue: "Venit lunar",
		administrationFee: "Taxă de administrare",
		openTickets: "Tichete deschise",
		occupied: "Ocupat",
		empty: "Gol",
	},
	table: {
		date: "Data",
		recipients: "Destinatari",
		addedDate: "Data adăugării",
		issuedDate: "Data emiterii",
		dueDate: "Data scadentă",
		paidDate: "Data plății",
		method: "Metoda",
		type: "Tip",
		owner: "Proprietar",
		address: "Adresă",
		status: "Stare",
		title: "Titlu",
		author: "Autor",
		endDate: "Data de încheiere",
		amount: "Sumă",
		tenant: "Chiriaș",
		currency: "Monedă",
		view: "Vizualizare",
		delete: "Ștergere",
		noData: "Nu există date de afișat",
		previousMonth: "Luna anterioară",
		nextMonth: "Luna următoare",
		rent: "Chirie",
		tenants: "Chiriași",
		lease: "Închiriere",
		statements: "Finante",
		administration: "Admin.",
		incomplete: "Incomplet",
		complete: "Complet",
		warning: "Atenție",
		empty: "Gol",
		expired: "Expirat",
		last10Activities: "Ultimele 10 activități",
		markAsPaid: "Marchează ca plătit",
		name: "Nume",
		number: "Număr",
		startingDate: "Data început",
		signatureDate: "Data semnării",
		expirationDate: "Data expirării",
		actions: "Acțiuni",
		download: "Descărcare",
		markAsActive: "Marchează ca activ",
		markAsInactive: "Marchează ca inactiv",
		due: "Scadent",
		overDue: "În întârziere",
		paid: "Plătit",
		rentReceived: "Chirie primită",
		administrationFee: "Comision de administrare",
		tax: "Taxe",
		centralHeating: "Centrală",
		insurance: "Asigurare",
		others: "Altele",
		subTotal: "Subtotal",
		year: "An",
		nextYear: "Anul viitor",
		previousYear: "Anul trecut",
		description: "Descriere",
		location: "Locație",
		custodian: "Custode",
		updatedDate: "Data actualizării",
		lastActivities: "Ultimele activități",
		statement: "Declarație Unică",
		c168: "C168",
		lastMessage: "Ultimul mesaj",
		price: "Preț",
		page: "Pagina",
		of: "din",
		viewDetails: "Vizualizare Detalii",
	},
	properties: {
		properties: "Proprietăți",
		addProperty: "Adaugă Proprietate",
		archivedProperties: "Proprietăți Arhivate",
		location: "Locație",
		keys: "Chei",
		agent: "Agent",
		bankDetails: "Detalii Bancare",
		owner: "Proprietar",
		street: "Stradă",
		buildingNumber: "Număr Clădire",
		blockNumber: "Număr Bloc",
		apartmentNumber: "Număr Apartament",
		entrance: "Intrare",
		area: "Zonă",
		city: "Oraș",
		county: "Județ",
		IBAN: "IBAN",
		administrationFeePercentage: "Procent comision de administrare",
		currency: "Monedă",
		name: "Nume",
		email: "Email",
		phoneNumber: "Număr de Telefon",
		verifyEmail: "Important: Verificați cu atenție adresa de email; nu poate fi modificată ulterior.",
		total: "Total",
		occupied: "Ocupat",
		empty: "Gol",
		iban: "IBAN",
		administrationFeePercent: "Procent comision de administrare",
		searchAddress: "Caută după adresă",
		searchOwner: "Caută după proprietar",
		searchTenant: "Caută după chiriaș",
		searchFormerTenant: "Caută după fost chiriaș",
		searchContact: "Caută după contact",
		searchGasPayment: "Caută după cod plată gaz",
		searchGasClient: "Caută după cod client gaz",
		searchWaterNLC: "Caută după cod NLC apă",
		searchWaterATM: "Caută după cod ATM apă",
		searchAdminStatus: "Caută după stare administrare",
		searchLeaseStatus: "Caută după stare închiriere",
		searchStatementStatus: "Caută după stare declarație",
		searchAssociation: "Caută după asociație",
		searchAssociationAdmin: "Caută după administrator asociație",
		searchAssociationEmail: "Caută după email asociație",
		uploadContract: "Încarcă contract",
		smartContract: "Contract inteligent",
		uploadDescription: "Încarcă un document PDF sau Word",
		contactType: "Tip Contact",
		fixedExchangeRate: "Curs fix",
		enterExchangeRate: "Introduceți cursul",
		noAssociationMessage: "Nu a fost adăugată nicio asociație la această proprietate",
	},
	outstanding: {
		outstanding: "De plată",
		missingRentPayment: "Plată chirii lipsă",
		noOutstandingPayments: "Nu există plăți restante",
	},
	utilities: {
		utilities: "Utilități",
		gas: "Gaz",
		water: "Apă",
		electricity: "Electricitate",
		sanitation: "Salubritate",
		internet: "Internet",
	},

	documents: {
		documents: "Documente",
		exportAsCsv: "Exportă ca CSV",
		type: "Tip",
	},

	financialStatus: {
		financialStatus: "Stare financiară",
		monthlyTotals: "Totaluri lunare",
		rentReceivedAndTransferred: "Chirie încasată și transferată",
		rentReceivedNotTransferred: "Chirie încasată și netransferată",
		rentNotReceived: "Chirie neîncasată",
		custodie: "Custodie",
		transferat: "Transferat",
		ownerAccount: "Cont proprietar",
		predareCash: "Predare numerar",
		exportFinancialStatus: "Exportă Situația Financiară",
	},
	statements: {
		statements: "Finante",
	},

	tickets: {
		tickets: "Tichete",
	},

	securityDeposits: {
		securityDeposits: "Garantii",
		totals: "Totaluri",
		custodyCash: "Custodie numerar",
		custodyBank: "Custodie bancară",
		owner: "Proprietar",
		total: "Total",
		returned: "Returnat",
		returnedTenant: "Returnat chiriașului",
	},
	property: {
		propertyDetails: "Detalii proprietate",
		archive: "Arhiveaza",
		restore: "Restaurează",
		general: "General",
		specs: "Specificații",
		images: "Imagini",
		contacts: "Contacte",
		utilities: "Utilități",
		payments: "Plăți",
		securityDeposits: "Garantii",
		financialStatements: "Finante",
		documents: "Documente",
		accounts: "Conturi",
		activities: "Activități",
		tenants: "Chiriași",
		notifications: "Notificări",
		tickets: "Tichete",
		messages: "Mesaje",
		location: "Locație",
		county: "Județ",
		city: "Oraș",
		area: "Zonă",
		street: "Stradă",
		buildingNumber: "Număr clădire",
		blockNumber: "Număr bloc",
		apartmentNumber: "Număr apartament",
		entrance: "Intrare",
		keys: "Chei",
		description: "Descriere",
		bankAccount: "Cont bancar",
		bankAccountCurrency: "Monedă cont bancar",
		administrationFeePercentage: "Procent comision de administrare",
		administration: "Administrație",
		lease: "Închiriere",
		financial: "Financiar",
		rentPrice: "Preț chirie",
		rentCollection: "Perioada Chirie",
		rentExchangeRate: "Curs Valutar Chirie",
		fixedAdministrationFee: "Comision de administrare fix",
		agent: "Agent",
		dateAdded: "Data adăugării",
		editRent: "Editează Chirie",
		editRentSubtitle: "Actualizați suma chiriei, intervalul de plată și setările cursului valutar",
		//images
		addMedia: "Adaugă Media",
		//contacts
		contactInformation: "Informații Contact",
		addContact: "Adaugă Contact",
		addAssociation: "Adaugă Asociație",
		association: "Asociație",
		editAssociation: "Editează Asociația",
		removeAssociation: "Șterge Asociația",
		name: "Nume",
		email: "Email",
		phoneNumber: "Număr de Telefon",
		phoneNumber2: "Număr de Telefon secundar",
		administratorName: "Administrator",
		iban: "IBAN",
		//utilities
		index: "Index",
		additionalIndex: "Additional Index",
		addIndex: "Adaugă Index",
		addUtilityInvoice: "Adaugă Factură de utilități",
		gas: "Gaz",
		electricity: "Electricitate",
		water: "Apă",
		sanitation: "Salubritate",
		internet: "Internet",
		history: "Istoric",
		requestMeterPicture: "Solicită Poza Contorului",
		gasIndex: "Gaz",
		electricityIndex: "Electricitate",
		waterIndex: "Apă",
		utilityPayments: "Plăți Utilități",
		markMultipleAsPaid: "Marchează Mai Multe ca Plătite",
		totalDue: "Total de plată",
		totalOverdue: "Total restant",
		requestPeriod: "Perioada de solicitare",
		collectionCode: "Cod Incasare",
		clientCode: "Cod Client",
		nlcCode: "Cod NLC",
		atmCode: "Cod ATM",
		//plăți
		addPayment: "Adaugă Plată",
		addRentPayment: "Adaugă Chirie",
		addAdministrationFeePayment: "Adaugă Comision de Administrare",
		editCustomOwnerPlanList: "Editează Pachetul de servicii",
		paymentDate: "Data plății",
		paymentDirection: "Direcția plății",
		documentNumber: "Număr Document",
		method: "Metoda",
		amount: "Sumă",
		currency: "Monedă",
		type: "Tip",
		billedTo: "Facturat către",
		billedToName: "Nume Facturat",
		billedToType: "Tip Facturat",
		//depozite de securitate
		addSecurityDeposit: "Adaugă Garantie",
		securityDepositDetails: "Detalii Garantie",
		addSecurityDepositSubtitle: "Adăugați o garanție nouă pentru această proprietate",
		depositInformation: "Informații Garanție",
		updateSecurityDepositSubtitle: "Actualizați informațiile garanției",
		depositSummary: "Rezumat Garanție",
		currentLocation: "Locație Curentă",
		updateInformation: "Actualizare Informații",
		notSpecified: "Nespecificat",
		deleteSecurityDepositConfirmation: "Sigur doriți să ștergeți această garanție?",
		documentNumberLabel: "Număr Document",
		documentNumberPlaceholder: "Introduceți numărul documentului",
		locationLabel: "Locație",
		amountLabel: "Sumă",
		amountPlaceholder: "Introduceți suma",
		currencyLabel: "Monedă",
		currencyPlaceholder: "Selectați moneda",
		custodianLabel: "Custode",
		custodianPlaceholder: "Introduceți numele custodelui",
		descriptionLabel: "Descriere",
		descriptionPlaceholder: "Introduceți descrierea",
		documentsLabel: "Documente",
		uploadDocuments: "Încărcați Documente",
		uploadDocumentsDescription: "Încărcați în format PDF, DOC sau DOCX",
		invalidInformation: "Informații invalide",
		securityDepositAdded: "Garanție adăugată cu succes",
		//extrasuri de cont financiar
		addFinancialStatement: "Adaugă Declaratie Finante",
		addFinancialStatementSubtitle: "Adăugați o declarație financiară sau C168 pentru această proprietate",
		financialStatementInformation: "Informații Declarație",
		financialStatementDetailsTitle: "Detalii Declarație Financiară",
		viewFinancialStatementSubtitle: "Vizualizați informațiile și documentele declarației",
		statementSummary: "Rezumat Declarație",
		deleteFinancialStatementConfirmation: "Sigur doriți să ștergeți această declarație financiară?",
		addTicketSubtitle: "Creați un tichet nou de suport pentru această proprietate",
		ticketInformation: "Informații Tichet",
		ticketDetailsTitle: "Detalii Tichet",
		viewTicketSubtitle: "Vizualizați și gestionați informațiile tichetului",
		ticketSummary: "Rezumat Tichet",
		ticketConversation: "Conversație",
		noRepliesYet: "Niciun răspuns încă",
		yourResponse: "Răspunsul Dvs.",
		typeYourMessage: "Scrieți mesajul aici...",
		markAsDone: "Marchează ca Rezolvat",
		deleteTicketConfirmation: "Sigur doriți să ștergeți acest tichet?",
		uploadImageOrVideo: "Încărcați o imagine sau un videoclip",
		titlePlaceholder: "Introduceți titlul",
		emitNotificationSubtitle: "Trimiteți o notificare chiriașilor proprietății",
		notificationInformation: "Informații Notificare",
		enterNotificationTitle: "Introduceți titlul notificării",
		enterNotificationMessage: "Introduceți mesajul aici...",
		sendMessageSubtitle: "Trimiteți un mesaj proprietarului sau chiriașului",
		messageInformation: "Informații Mesaj",
		messageDetailsTitle: "Detalii Mesaj",
		viewMessageSubtitle: "Vizualizați și răspundeți la mesaj",
		messageReplies: "Răspunsuri",
		addReply: "Adaugă Răspuns",
		addAssociationSubtitle: "Asociați o asociație de locatari cu această proprietate",
		editAssociationSubtitle: "Actualizați informațiile asociației pentru această proprietate",
		associationInformation: "Informații Asociație",
		associationSource: "Sursă Asociație",
		ownerHandlesFinancials: "Proprietarul Se Ocupă de Finante",
		//documente
		addDocument: "Adaugă Document",
		addProtocol: "Adaugă Proces Verbal",
		tenantAssociationNotification: "Notificare Asociație Chiriași",
		protocols: "Procese Verbale",
		//conturi
		addAccount: "Adaugă Cont",
		accountInformation: "Informații Cont",
		provider: "Furnizor",
		userName: "Nume Utilizator",
		password: "Parolă",
		//activități
		addActivity: "Adaugă Activitate",
		//chiriași
		addLease: "Adaugă Contract de Închiriere",
		addAdditionalDocument: "Adaugă Document Adițional",
		addTenant: "Adaugă Chiriaș",
		addReport: "Adaugă Proces Verbal",
		ownerHandlesSanitationDeclaration: "Proprietarul Se Ocupă de Declaratia de Salubritate",
		formerTenants: "Chiriași Anteriori",
		formerContacts: "Contacte Anterioare",
		reports: "Procese Verbale",
		markFormer: "Marchează ca fost chiriaș",
		markActive: "Marchează ca activ",
		//notificări
		sendNotification: "Trimite Notificare",
		systemNotifications: "Notificări de Sistem",
		noNotifications: "Nu Există Notificări",
		notificationsWillAppearHere: "Notificările dvs. vor apărea aici",
		noSystemNotifications: "Nu Există Notificări de Sistem",
		systemNotificationsWillAppearHere: "Notificările de sistem vor apărea aici",
		emitNotification: "Emite Notificare",
		notificationTitle: "Titlu Notificare",
		notificationMessage: "Mesaj",
		enterTitle: "Introduceți titlul...",
		enterMessage: "Introduceți mesajul...",
		notifyOwner: "Notifică Proprietarul",
		addTenantsToEnable: "Adăugați chiriași pentru a activa notificările",
		message: "Mesaj",
		//tichete
		addTicket: "Adaugă Tichet",
		//mesaje
		sendMessage: "Trimite Mesaj",
		enterDescription: "Introduceți descrierea activității...",
		selectType: "Selectați tipul activității",
		enterAmount: "Introduceți suma",
		//accounts
		showPassword: "Arată Parola",
		hidePassword: "Ascunde Parola",
		enterPassword: "Introduceți parola",
		selectAccountType: "Selectați tipul de cont",
		enterProvider: "Introduceți furnizorul",
		enterUsername: "Introduceți numele de utilizator",
		accountType: "Tip de cont",
		rentPaymentInterval: "Interval de plată chirie",
		selectCurrency: "Selectați moneda",
		contactList: "Listă Contacte",
		namePlaceholder: "Introduceți numele",
		emailPlaceholder: "Introduceți adresa de email",
		phoneNumberPlaceholder: "Introduceți numărul de telefon",
		alternativePhone: "Număr de Telefon Alternativ",
		selectContactType: "Selectați tipul de contact",
		existingAssociation: "Asociație Existentă",
		newAssociation: "Asociație Nouă",
		associationNamePlaceholder: "Introduceți numele asociației",
		administratorNamePlaceholder: "Introduceți numele administratorului",
		ibanPlaceholder: "Introduceți IBAN",
		selectAssociation: "Selectați Asociația",
		selectAssociationPlaceholder: "Alegeți o asociație",
		confirmDelete: "Confirmați Ștergerea",
		deleteAssociationConfirmation: "Sunteți sigur că doriți să eliminați asociația de la această proprietate?",
		actionCannotBeUndone: "Această acțiune nu poate fi anulată!",
		enterCustomAmount: "Introduceți o sumă personalizată",
		confirm: "Confirmă",
		rentPaymentDisclaimer: "Prin emiterea manuală a unei plăți de chirie, alta nu va fi emisă automat de sistem în această lună.",
		admFeePaymentDescription:
			"Adăugați o factură pentru comisionul de administrare standard sau cu o valoare personalizată. Puteți include sau exclude pachete de servicii prin bifarea căsuțelor corespunzătoare.",
		alreadyPaid: "Deja plătit?",
		customValue: "Valoare personalizată?",
		enterValue: "Introduceți valoarea",
		selectServices: "Selectați ce servicii doriți să includeți în această plată",
		editMonthlyServices: "Editează pachetul de servicii lunare",
		monthlyServicesDescription:
			"Selectați pachetul de servicii dorit pentru această proprietate. Acestea se vor adăuga automat la valoarea comisionului de administrare lunar.",
		estimatedTotal: "Total estimat",
		perMonth: "pe lună",
		financialStatementAdded: "Declarație financiară adăugată cu succes",
		notAvailable: "N/A",
		firstDay: "Prima Zi",
		lastDay: "Ultima Zi",
		fixedExchangeRate: "Curs fix",
		enterExchangeRate: "Introduceți cursul",
		noAssociationMessage: "Nu a fost adăugată nicio asociație la această proprietate",
		addPaymentSubtitle: "Adăugați o plată nouă pentru această proprietate",
		addRentPaymentSubtitle: "Adăugați plata chiriei pentru această proprietate",
		addAdmFeePaymentSubtitle: "Adăugați plata comisionului de administrare",
		editMonthlyServicesSubtitle: "Configurați serviciile lunare pentru această proprietate",
		completePaymentInfo: "Completați informațiile plății",
		paymentSummary: "Rezumat Plată",
		paymentDetails: "Detalii Plată",
		paymentDetailsTitle: "Detalii Plată",
		viewPaymentSubtitle: "Vizualizați informațiile și documentele plății",
		billingInformation: "Informații Facturare",
		billingDetails: "Detalii Facturare",
		paymentInformation: "Informații Plată",
		supportingDocuments: "Documente Justificative",
		paymentTimeline: "Cronologie Plată",
		existingDocuments: "Documente Existente",
		addNewDocument: "Adaugă Document Nou",
		noDocumentsAttached: "Nu există documente atașate",
		clickToDownload: "Click pentru descărcare",
		documentReady: "Document Pregătit",
		documentReadyDescription: "{{name}} este pregătit pentru încărcare",
		deletePaymentConfirmation: "Sigur doriți să ștergeți această plată?",
		currencyExchange: "Schimb Valutar",
		billedInDifferentCurrency: "Facturat în altă monedă",
		exchangeRateInfo: "Informații Curs Valutar",
		equivalentAmount: "Sumă Echivalentă",
		notPaidYet: "Neplătit încă",
		issueDate: "Data Emiterii",
		paymentAmount: "Suma Plății",
		feeConfiguration: "Configurare Comision",
		selectAmountType: "Selectați Tipul Sumă",
		currentRentAmount: "Chiria Curentă",
		customAmount: "Sumă Personalizată",
		enterDifferentAmount: "Introduceți o sumă diferită",
		currentAdministrationFee: "Comision Administrare Curent",
		availableServices: "Servicii Disponibile",
		monthlyServices: "Servicii Lunare",
		selectRecipient: "Selectați destinatarul",
		uploadPdfDocDocx: "Încărcați fișiere PDF, DOC sau DOCX",
		addDocumentSubtitle: "Adăugați un document al proprietății cu date și fișier",
		addProtocolSubtitle: "Adăugați un proces verbal cu media opțională",
		documentInformation: "Informații Document",
		protocolDetailsTitle: "Detalii Proces Verbal",
		viewProtocolSubtitle: "Vizualizați informațiile și media procesului verbal",
		protocolSummary: "Rezumat Proces Verbal",
		protocolDocument: "Document Proces Verbal",
		mediaGallery: "Galerie Media",
		noMediaAttached: "Nu există media atașată",
		isActiveDocument: "Este activ?",
		uploadMediaDescription: "Încărcați o imagine sau un video",
		markMultipleAsPaidSubtitle: "Marcați mai multe plăți utilități ca plătite simultan",
		selectPayments: "Selectați Plățile",
		addUtilityInvoiceSubtitle: "Adăugați o factură utilitate pentru această proprietate",
		utilityInvoiceAlertTitle: "Factură Utilitate",
		utilityInvoiceAlertDescription: "Adăugați facturi pentru electricitate, gaz, apă sau alte servicii",
		invoiceDetails: "Detalii Factură",
		invoiceDocument: "Document Factură",
		utilityType: "Tip Utilitate",
		selectUtilityType: "Selectați tipul utilității",
		historySubtitle: "Vizualizați indexurile contoarelor și istoricul utilităților",
		gasMeterHistory: "Istoric Contor Gaz",
		electricityMeterHistory: "Istoric Contor Electricitate",
		waterMeterHistory: "Istoric Contor Apă",
		noMeterPicturesYet: "Nu există încă poze ale contoarelor.",
		requestMeterPictureSubtitle: "Solicitați poze ale contoarelor de la chiriași",
		meterPictureRequestTitle: "Solicitare Poze Contoare",
		meterPictureRequestDescription: "Selectați ce poze de contoare doriți să solicitați de la chiriași",
		selectMeters: "Selectați Contoarele",
		waterMeter: "Contor Apă",
		electricityMeter: "Contor Electricitate",
		gasMeter: "Contor Gaz",
		requestWaterMeterReading: "Solicitați indexul curent al contorului de apă",
		requestElectricityMeterReading: "Solicitați indexul curent al contorului de electricitate",
		requestGasMeterReading: "Solicitați indexul curent al contorului de gaz",
		addIndexSubtitle: "Adăugați o citire nouă a contorului pentru această proprietate",
		meterReadingTitle: "Citire Contor",
		meterReadingDescription: "Înregistrați indexul curent al contorului pentru electricitate, gaz sau apă",
		meterInformation: "Informații Contor",
		meterType: "Tip Contor",
		selectMeterType: "Selectați tipul contorului",
		newIndex: "Index Nou",
		enterIndexValue: "Introduceți valoarea indexului",
		additionalIndexOptional: "Index Suplimentar (opțional)",
		enterAdditionalIndex: "Introduceți indexul suplimentar",
		editMeterTitle: "Editare Contor {{type}}",
		editMeterSubtitle: "Actualizați configurația și setările contorului",
		meterCodes: "Coduri Contor",
		paymentCode: "Cod Plată",
		collectionPeriod: "Perioada de Colectare",
		collectionPeriodHint: "Introduceți o zi între 1 și 31 pentru perioada de colectare",
		cleaning: "Curățenie",
		addAdditionalDocumentSubtitle: "Adăugați un document suplimentar pentru această proprietate",
		documentUpload: "Încărcare Document",
		documentStatus: "Status",
		addTenantSubtitle: "Adăugați un chiriaș nou sau selectați unul existent",
		tenantType: "Tip Chiriaș",
		newTenant: "Chiriaș Nou",
		existingTenant: "Chiriaș Existent",
		selectExistingTenant: "Selectați Chiriaș Existent",
		searchSelectTenant: "Căutați și Selectați Chiriaș",
		searchExistingTenantsPlaceholder: "Căutați chiriași existenți...",
		noTenantsFound: "Nu s-au găsit chiriași",
		loadingTenants: "Se încarcă chiriașii...",
		selectedTenant: "Chiriaș Selectat",
		newTenantInformation: "Informații Chiriaș Nou",
		fullName: "Nume Complet",
		emailAddress: "Adresă Email",
		addSelectedTenant: "Adaugă Chiriaș Selectat",
		addNewTenant: "Adaugă Chiriaș Nou",
		addContactSubtitle: "Adăugați un contact nou pentru această proprietate",
		contactDetails: "Detalii Contact",
		contactInformationAlert: "Adăugați detaliile de contact pentru comunicări și administrarea proprietății.",
		addLeaseSubtitle: "Adăugați un contract de închiriere pentru această proprietate",
		financialInformation: "Informații Financiare",
		exchangeRateConfiguration: "Configurare Curs Valutar",
		administrationFeeOptional: "Comision Administrare (Opțional)",
		leaseDocument: "Document Contract",
		firstRentDay: "Prima Zi Chirie",
		lastRentDay: "Ultima Zi Chirie",
		addReportSubtitle: "Adăugați un raport nou pentru această proprietate",
		reportInformation: "Informații Raport",
		reportDocument: "Document Raport",
		mediaFiles: "Fișiere Media",
		uploadImagesOrVideos: "Încărcați imagini sau video",
		rentRevenueSummaryTitle: "Rezumat Venit Chirie",
		rentRevenueSummarySubtitle: "Venit generat pentru această perioadă de contract",
		leasePeriod: "Perioada Contractului",
		startDate: "Data Început",
		endDate: "Data Sfârșit",
		generatedRevenue: "Venit Generat",
		eurRevenue: "Venit EUR",
		ronRevenue: "Venit RON",
		totalRevenue: "Venit Total",
		reportDetailsTitle: "Detalii Raport",
		viewReportSubtitle: "Vizualizați informațiile și media raportului",
		reportSummary: "Rezumat Raport",
		activeLabel: "Activ",
		inactiveLabel: "Inactiv",
	},
	activityTypes: {
		insurance: "Asigurare",
		administrationContract: "Contract de administrare",
		lease: "Contract de închiriere",
		email: "Email",
		whatsapp: "WhatsApp",
		conversation: "Convorbire",
		other: "Altele",
	},
	misc: {
		loading: "Se încarcă...",
		search: "Căutare...",
		legend: "Legendă",
		cancel: "Anulare",
		close: "Închide",
		save: "Salvare",
		edit: "Editează",
		send: "Trimite",
		add: "Adaugă",
		delete: "Șterge",
		request: "Solicită",
		showPassword: "Arată Parola",
		hidePassword: "Ascunde Parola",
	},
	notifications: {
		sendNotification: "Trimite Notificare",
		title: "Titlu",
		enterTitle: "Introduceți titlul notificării",
		message: "Mesaj",
		enterMessage: "Introduceți mesajul aici...",
		recipientType: "Tip Destinatar",
		singleProperty: "Proprietate Unică",
		multipleUsers: "Mai Mulți Utilizatori",
		selectProperty: "Selectați Proprietatea",
		chooseProperty: "Alegeți o proprietate",
		includeOwner: "Include Proprietarul",
		allOwners: "Toți Proprietarii",
		allTenants: "Toți Chiriașii",
		send: "Trimite Notificare",
		propertyNotifications: "Notificări Proprietate",
		massNotifications: "Notificări în Masă",
		notifications: "Notificări",
		noPropertyNotifications: "Nu există notificări pentru proprietăți.",
		noMassNotifications: "Nu există notificări în masă.",
		massNotification: "Notificare în Masă",
		propertyNotification: "Notificare Proprietate",
		recipients: "Destinatari",
		sent: "Trimis",
		showMore: "Arată Mai Multe",
		copyAllEmails: "Copiază Toate Email-urile",
		emailsCopied: "Email-uri copiate în clipboard",
		searchRecipients: "Căutare destinatari",
	},
	financialStatements: {
		title: "Situații financiare",
		description: "Vizualizați și descărcați situațiile financiare pentru proprietățile dvs.",
		noStatements: "Nu există situații financiare disponibile pentru anul selectat",
	},
};
